module.exports = __webpack_public_path__ + "img/A3-south-africa.82908da3.png";